import { hideDialog, refresher, toastError } from "../../../redux/guest-slices/other.slice"
import { createBlogCategory, updateBlogCategory } from "../../../redux/admin-slices/blogs.slice"
import { CREATE_BLOG_CATEGORY } from "../../../utils/keywords"
import { useDispatch, useSelector } from "react-redux"
import InputFieldA from "../../ui/InputFieldA"
import Icons from "../../../assets/js/Icons"

import {
  Box, Button, CircularProgress, DialogActions, DialogContent,
  DialogTitle, IconButton, Paper, Stack, Typography
} from "@mui/material"

function BlogCategory() {
  const dispatch = useDispatch()
  const { type, data, loadings } = useSelector(state => state.otherSlice)

  // Close dialog
  const handleClose = () => {
    dispatch(hideDialog())
  }

  // Handle create  
  const handleSubmit = (e) => {
    e.preventDefault()
    const form = e.target
    const formData = Object.fromEntries(new FormData(form))
    formData.slug = formData?.slug.replace(/^-+|-+$/g, '')
    if ([
      formData?.name,
      formData?.slug,
    ]?.some((value) => value?.trim() === "" || !value)
    ) {
      return dispatch(toastError("Please fill all required field!"))
    }

    if (type === CREATE_BLOG_CATEGORY) {
      dispatch(createBlogCategory(formData)
      ).unwrap().then(() => {
        setTimeout(() => {
          handleClose()
          dispatch(refresher())
        }, 500)
      }).catch(() => { })
    } else {
      dispatch(updateBlogCategory({
        formData,
        categoryId: data?.category?._id,
      })
      ).unwrap().then(() => {
        setTimeout(() => {
          handleClose()
          dispatch(refresher())
        }, 500)
      }).catch(() => { })
    }

  }

  // Handle slug input
  const handleSlug = (e) => {
    e.target.value = e.target.value
      .toLowerCase()
      .replace(/[^a-zA-Z- ]/g, "")
      .replace(/ /g, '-')
      .replace(/-+/g, "-")
  }

  return (
    <Paper component="form" onSubmit={handleSubmit}>
      <DialogTitle sx={{ position: "relative" }}>
        <Typography
          sx={{
            m: "0",
            fontSize: "24px",
            fontWeight: "600",
            textAlign: "center",
          }}
        >Create New Category
        </Typography>
        <IconButton
          sx={{
            top: "10px",
            right: "10px",
            color: "other.color1",
            position: "absolute",
          }}
          size="small"
          onClick={handleClose}
        ><Icons.CancelSolid />
        </IconButton>
      </DialogTitle>
      <DialogContent
        className="relative"
        sx={{
          ".MuiInputBase-root": { borderRadius: "6px" },
        }}
      >
        <Stack spacing={1.5}>
          <Box>
            <InputFieldA
              type="text"
              name="name"
              placeholder="Enter Name"
              value={data?.category?.name}
              label={<>
                Name*
                <Typography
                  variant="body2"
                  component="span"
                  color="inherit"
                > (In any language)
                </Typography>
              </>}
            />
          </Box>
          <Box>
            <InputFieldA
              type="text"
              name="slug"
              placeholder="Enter Slug"
              onChangeFun={handleSlug}
              value={data?.category?.slug}
              label={<>
                Slug*
                <Typography
                  variant="body2"
                  component="span"
                  color="inherit"
                > (In English)
                </Typography>
              </>}
            />
          </Box>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", px: 3 }}>
        <Button
          type="submit"
          color="success"
          variant="contained"
          sx={{ minWidth: 120 }}
          endIcon={(
            loadings?.create ||
            loadings?.update
          ) &&
            <CircularProgress
              size={20}
              thickness={5}
              sx={{ color: "white" }}
            />
          }
        >
          {type === CREATE_BLOG_CATEGORY ?
            "Create" : "Update"
          }
        </Button>
      </DialogActions>
    </Paper>
  )
}

export default BlogCategory